import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth, connectAuthEmulator } from 'firebase/auth';
import { initializeAppCheck, ReCaptchaV3Provider } from 'firebase/app-check';
import { collection } from 'firebase/firestore';

// Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCqN9be2DX42Gta-XSjvJtb3FVrmgTwQsg",
  authDomain: "maziwa-da882.firebaseapp.com",
  projectId: "maziwa-da882",
  storageBucket: "maziwa-da882.appspot.com",
  messagingSenderId: "170152378978",
  appId: "1:170152378978:web:3a40015f552e034c35473b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize App Check
if (process.env.NODE_ENV === 'production') {
  // @ts-ignore - App Check types will be available after package installation
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider('6LfXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX'), // Replace with your reCAPTCHA v3 site key
    isTokenAutoRefreshEnabled: true
  });
}

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

// Test connection
export const testFirebaseConnection = async () => {
  try {
    console.log('Testing Firebase connection...');
    console.log('Project ID:', firebaseConfig.projectId);
    console.log('Auth domain:', firebaseConfig.authDomain);
    
    // Test auth
    const currentUser = auth.currentUser;
    console.log('Current user:', currentUser?.email || 'None');
    
    // Test Firestore
    const testCollection = collection(db, 'test');
    console.log('Firestore initialized successfully');
    
    return true;
  } catch (error) {
    console.error('Firebase connection test failed:', error);
    return false;
  }
};

export default app; 